export enum ButtonType {
    Default = 'default',
    Pill    = 'pill',
}